import MsCopilot from "@/assets/images/hosting/Microsoft-Copilot.webp";
import EmailBackup from "@/assets/images/hosting/backup.webp";
import MsBI from "@/assets/images/hosting/MS-BI.webp";
import EmailSecurity from "@/assets/images/hosting/Email-Security.webp";
import EmailMigration from "@/assets/images/hosting/Email-Migration.webp";
import MsVisio from "@/assets/images/hosting/MsViso.webp";
import MsPlanner from "@/assets/images/hosting/MsPlanner.webp";
import { useNavigate } from "react-router-dom";

export default function AdditionalEmailTools() {
    const navigate = useNavigate();
    const tools = [
        {
            title: "Microsoft Copilot",
            description: "Work smarter with AI that helps summarize conversations, organize emails, generate content, and surface insights across your daily Microsoft apps.",
            image: MsCopilot
        },
        {
            title: "Email Backup",
            description: "Keep your important emails, contacts, and calendars safe with automatic backups and fast recovery whenever you need it.",
            image: EmailBackup
        },
        {
            title: "Microsoft BI",
            description: "Turn raw data into clear insights with powerful analytics that help you monitor performance and make confident business decisions.",
            image: MsBI
        }
    ];

    const services = [
        {
            title: "Advanced Email Security",
            description: "Stay protected with intelligent email security that filters spam, detects malicious links, blocks harmful attachments, and warns you about potential threats.",
            image: EmailSecurity
        },
        {
            title: "Email Migration",
            description: "Move your professional email from another provider with minimal downtime. Our migration service ensures a smooth, secure, and hassle-free transfer.",
            image: EmailMigration
        },
        {
            title: "Microsoft Visio",
            description: "Create clear, visual diagrams that help teams explain ideas, workflows, and systems more effectively across your organization.",
            image: MsVisio
        },
        {
            title: "Microsoft Planner",
            description: "Plan projects, assign tasks, and track progress easily with collaborative tools designed to keep your team aligned and productive.",
            image: MsPlanner
        }
    ];

    return (
        <section className="pb-16 md:pb-28 md:pt-6 relative overflow-hidden bg-gradient-to-b from-transparent to-purple-900/5">
            <div className="container">
                {/* Header */}
                <div className="text-center mb-16">
                    <span className="inline-flex items-center gap-2 px-4 py-2 mb-6 bg-white/5 rounded-full border border-white/10 backdrop-blur-sm text-xs md:text-sm font-semibold text-gray-300 tracking-wider uppercase">
                        Built for Productivity
                    </span>
                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                        Powerful email tools built to support your growth.
                    </h2>
                </div>

                {/* Tools Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10 max-w-6xl mx-auto">
                    {tools.map((tool, index) => (
                        <div key={index} className="group">
                            <div className="bg-gradient-to-br from-purple-600/5 to-blue-600/5 rounded-2xl p-6 border border-purple-500/20 hover:border-purple-500/50 transition-all duration-300 h-full flex flex-col">
                                <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 rounded-xl h-48 md:h-32 lg:h-48 mb-6 overflow-hidden">
                                    <img 
                                        src={tool.image} 
                                        alt={tool.title}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <h3 className="text-xl font-bold text-white mb-3">
                                    {tool.title}
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed flex-grow">
                                    {tool.description}
                                </p>
                                {/* <button className="px-6 py-2.5 border-2 border-purple-500/30 text-white rounded-lg hover:border-purple-500/50 hover:bg-purple-500/10 transition-all font-semibold">
                                    Get Started
                                </button> */}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Services Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
                    {services.map((service, index) => (
                        <div key={index} className="group">
                            <div className="bg-gradient-to-br from-purple-600/5 to-blue-600/5 rounded-2xl p-6 border border-purple-500/20 hover:border-purple-500/50 transition-all duration-300 h-full flex flex-col">
                                <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 rounded-xl h-40 mb-6 overflow-hidden">
                                    <img 
                                        src={service.image} 
                                        alt={service.title}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <h3 className="text-lg font-bold text-white mb-3">
                                    {service.title}
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed flex-grow">
                                    {service.description}
                                </p>
                                {/* <button className="px-6 py-2 border-2 border-purple-500/30 text-white rounded-lg hover:border-purple-500/50 hover:bg-purple-500/10 transition-all font-semibold text-sm">
                                    Get Started
                                </button> */}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="text-center mt-12">
                    <button
                        onClick={() => navigate("/request-for-services")}
                        className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white font-semibold py-3.5 px-6 lg:px-12 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg"
                        >
                        Get Started
                    </button>
                </div>
            </div>
        </section>
    );
}